import axios from 'axios'
import { hostUI } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
    records: [],
    pagination: {
        totalRecords: 0,
        totalPages: 1,
        currentPage: 1,
        limit: 10
    },
    loading: false,
    error: null
}

const OBTENER_TERMINADO_LISTA = 'bitacoraEnvasadoTerminado/obtenerLista'
const GUARDAR_TERMINADO_RECORD = 'bitacoraEnvasadoTerminado/guardarRecord'

export const obtenerTerminadoRecords = createAsyncThunk(
    OBTENER_TERMINADO_LISTA,
    async (params, { rejectWithValue }) => {
        try {
            let idLogin = null;
            let page = 1;
            let limit = 20;
            let search = '';

            if (typeof params === 'object' && params !== null) {
                idLogin = params.idLogin || params.id_login || null;
                page = params.page || 1;
                limit = params.limit || 20;
                search = params.search || '';
            } else {
                idLogin = params;
            }

            const queryParts = [];
            if (idLogin) queryParts.push(`id_login=${idLogin}`);
            if (page) queryParts.push(`page=${page}`);
            if (limit) queryParts.push(`limit=${limit}`);
            if (search) queryParts.push(`search=${encodeURIComponent(search)}`);

            const queryString = queryParts.length ? `?${queryParts.join('&')}` : '';
            const url = `${hostUI}bitacora-envasado/terminado${queryString}`;

            const res = await axios.get(url);
            return {
                records: res.data.data || [],
                pagination: res.data.pagination || { totalRecords: (res.data.data || []).length, totalPages: 1, currentPage: 1, limit: 20 }
            };
        } catch (error) {
            console.error("Error al obtener registros de envasado terminado:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

export const guardarTerminadoRecord = createAsyncThunk(
    GUARDAR_TERMINADO_RECORD,
    async (recordData, { rejectWithValue }) => {
        try {
            const url = `${hostUI}bitacora-envasado/terminado`;
            const res = await axios.post(url, recordData);
            return res.data.data;
        } catch (error) {
            console.error("Error al guardar envasado terminado:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

const bitacoraEnvasadoTerminadoSlice = createSlice({
    name: 'bitacoraEnvasadoTerminado',
    initialState,
    reducers: {
        resetTerminadoError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(obtenerTerminadoRecords.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(obtenerTerminadoRecords.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.records = payload.records;
                state.pagination = payload.pagination;
            })
            .addCase(obtenerTerminadoRecords.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            .addCase(guardarTerminadoRecord.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.records.unshift(payload);
            });
    }
});

export const { resetTerminadoError } = bitacoraEnvasadoTerminadoSlice.actions;
export default bitacoraEnvasadoTerminadoSlice.reducer;
